import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableHeader } from '../tableConfig';
import withImageSlider from '../../../../utils/composition/withImageSlider';
import { Pagination } from '../../../../v4/components';
import withErrorAndLoadingScreen from '../../../../utils/composition/withLoading';
import { BulkSelect } from '../../../../v4/components';
import { dataProps, paginationProps } from '../../../../data/enums/Component';
import { PERMISSION_OBJ } from '../../../../data/enums/Permission';
import { ALERT_TYPE } from '../../../../data/enums/AlertType';
import withAlert from '../../../../utils/composition/withAlert';

const propTypes = {
  tableConfig: PropTypes.arrayOf(Object).isRequired,
  pending: dataProps.value,
  onPageChange: PropTypes.func,
  permission: PropTypes.instanceOf(Object),
  fetchAllData: PropTypes.func,
  pagination: paginationProps.value,
  handleSliderOpen: PropTypes.func.isRequired,
  displayAlert: PropTypes.func.isRequired,
};

const defaultProps = {
  pending: dataProps.defaultValue,
  onPageChange: () => null,
  permission: PERMISSION_OBJ,
  fetchAllData: () => null,
  pagination: paginationProps.defaultValue,
};

class Pending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog: {
        type: '',
        element: '',
      },
    };
  }

  handleIconClick = (type, element = {}) => {
    this.setState({
      dialog: {
        type,
        element,
      },
    });
  };

  resetDialog = () => {
    this.setState({
      dialog: {
        type: '',
        element: '',
      },
    });
  };

  getStatus = (status, statusType) => {
    const { displayAlert } = this.props;
    displayAlert(ALERT_TYPE[statusType === 'err' ? 'INFO' : 'SUCCESS'], status);
  };

  render() {
    const { dialog } = this.state;
    const { type } = dialog;
    const { tableConfig, pending, pagination, onPageChange, handleSliderOpen, fetchAllData, permission,onTableRowClick,onHeaderClick} = this.props;
    const filterTableConfig = tableConfig;

    return (
      <Fragment>

        <BulkSelect
          data={pending.list}
          fetchAllData={fetchAllData}
         
          render={(checkedList, primaryCheckboxHandler, secondaryCheckboxHandler) => (
            <div className="table-wrap">
              <table>
                {TableHeader({
                  tableConfig: filterTableConfig,
                  dataListLength: pending.list.length,
                  onHeaderClick
                })}

                <tbody>
                  {pending.list.map(pendings =>
                    TableBody({
                      data: pendings,
                      onIconClick: this.handleIconClick,
                      tableConfig: filterTableConfig,
                      handleSliderOpen,
                      checkedList: checkedList,
                      secondaryCheckboxHandler,
                      section: 'pending',
                      permission,
                      pendingAction: true,
                      onTableRowClick
                    }),
                  )}
                </tbody>
              </table>
            </div>
          )}
        />

        <Pagination
          currentPage={pagination.page}
          limit={pagination.limit}
          totalItems={pending.total}
          onPageChange={onPageChange}
        />
      </Fragment>
    );
  }
}

Pending.propTypes = propTypes;

Pending.defaultProps = defaultProps;

const PendingWithErrorAndLoading = withErrorAndLoadingScreen(Pending);

const PendingWithImageSlider = withImageSlider(PendingWithErrorAndLoading);

export default withAlert()(PendingWithImageSlider);
